export default {
  // Header
  'header.fontSize': 'ఫాంట్ పరిమాణం',
  'header.theme': 'థీమ్',
  'header.language': 'భాష',
  'header.english': 'English',
  'header.telugu': 'తెలుగు',
  'header.home': 'హోమ్',
  'header.about': 'మా గురించి',
  'header.aboutFunctions': 'విధులు',
  'header.aboutCitizenCharter': 'పౌర ప్రతిజ్ఞ',
  'header.aboutTeam': 'బృందం',
  'header.services': 'సేవలు',
  'header.resources': 'వనరులు',
  'header.resourcesActsByLaws': 'చట్టాలు & ఉపనియమాలు',
  'header.resourcesGosCirculars': "GO లు & సర్క్యులర్‌లు",
  'header.resourcesFaqs': 'తరచుగా అడిగే ప్రశ్నలు',
  'header.resourcesTraining': 'శిక్షణ సామగ్రి',
  'header.gisMap': 'GIS మ్యాప్',
  'header.rti': 'RTI',
  'header.contact': 'సంప్రదించండి',
  'header.helpDesk': 'హెల్ప్ డెస్క్',
  'header.login': 'లాగిన్',
  'header.logout': 'లాగౌట్',
  'header.gotoERP': 'ERP కు వెళ్ళండి',
  'header.govtOfAP': 'ఆంధ్రప్రదేశ్ ప్రభుత్వం',
  'header.dtcp': 'పట్టణ మరియు గ్రామీణ ప్రణాళిక సంచాలకం',
  'header.department': 'MA & UD శాఖ, ఆంధ్రప్రదేశ్ ప్రభుత్వం',
  'header.dtcpShort': 'DTCP',
  'header.cmName': 'శ్రీ నారా చంద్రబాబు నాయుడు',
  'header.cmTitle': 'గౌరవనీయ ముఖ్యమంత్రి, ఆంధ్రప్రదేశ్',
  'header.ministerName': 'శ్రీ పొంగూరు నారాయణ',
  'header.ministerTitle': 'గౌరవనీయ మంత్రి, MA&UD',

  // Hero Carousel
  'hero.slide1.badge': 'భవన అనుమతులు',
  'hero.slide1.title': 'పట్టణ అభివృద్ధి ఆమోదాలను సులభతరం చేయడం',
  'hero.slide1.subtitle': 'DTCP ఆంధ్రప్రదేశ్ 110+ పట్టణ స్థానిక సంస్థల కోసం భవన అనుమతులు, లేఅవుట్ ఆమోదాలు మరియు క్రమబద్ధీకరణ అభ్యర్థనలను ప్రాసెస్ చేస్తుంది — వేగంగా, పారదర్శకంగా మరియు పూర్తిగా ఆన్‌లైన్‌లో.',
  'hero.slide1.cta': 'లేఅవుట్ ఆమోదం కోసం దరఖాస్తు చేయండి',
  'hero.slide2.badge': 'మాస్టర్ ప్లాన్లు',
  'hero.slide2.title': 'పారదర్శక ప్రణాళిక & లేఅవుట్ వ్యవస్థలు',
  'hero.slide2.subtitle': 'అన్ని జిల్లాల కోసం జియో-రిఫరెన్స్‌డ్ మాస్టర్ ప్లాన్‌లు, భూ వినియోగ జోనింగ్ మ్యాప్‌లు మరియు అభివృద్ధి నిబంధనలను యాక్సెస్ చేయండి — ప్రతి పౌరునికి బహిరంగంగా అందుబాటులో.',
  'hero.slide2.cta': 'మాస్టర్ ప్లాన్లు చూడండి',
  'hero.slide3.badge': 'భూ వినియోగ నియంత్రణ',
  'hero.slide3.title': 'ప్రతి జిల్లాకు నియంత్రిత వృద్ధి',
  'hero.slide3.subtitle': 'DTCP అభివృద్ధి నియంత్రణ నిబంధనలను అమలు చేస్తుంది, భూ వినియోగ ధృవీకరణ పత్రాలు జారీ చేస్తుంది మరియు AP అంతటా CRDA, GHMC మరియు అన్ని ప్రణాళిక అధికారులతో సమన్వయం చేస్తుంది.',
  'hero.slide3.cta': 'భూ వినియోగ ధృవీకరణ పత్రం',
  'hero.slide4.badge': 'ఆన్‌లైన్ సేవలు',
  'hero.slide4.title': 'పౌర-ప్రథమ డిజిటల్ ప్రణాళిక సేవలు',
  'hero.slide4.subtitle': 'దరఖాస్తు చేయండి, ట్రాక్ చేయండి, డౌన్‌లోడ్ చేయండి మరియు ధృవీకరించండి — మీ అన్ని ప్రణాళిక అనుమతులు మరియు ధృవీకరణ పత్రాలు DPMS పోర్టల్‌లో 24×7 అందుబాటులో.',
  'hero.slide4.cta': 'DPMS పోర్టల్ తెరవండి',
  'hero.slide5.badge': 'ప్రదర్శన పరికరాలు — GO Ms.No.253',
  'hero.slide5.title': 'నియంత్రిత బహిరంగ ప్రకటనలు',
  'hero.slide5.subtitle': 'అన్ని బహిరంగ ప్రకటనలు — హోర్డింగ్‌లు, యూనిపోల్‌లు, డిజిటల్ స్క్రీన్‌లు, బ్యానర్లు — ఇకపై మీ ULB నుండి లైసెన్స్ మరియు అనుమతి అవసరం.',
  'hero.slide5.cta': 'లైసెన్స్ కోసం దరఖాస్తు చేయండి',

  // Flash News
  'flash.label': 'తాజా వార్తలు',

  // About Section
  'about.label': 'మా గురించి',
  'about.title': 'DTCP ఆంధ్రప్రదేశ్ గురించి',
  'about.description1': '<strong>పట్టణ మరియు గ్రామీణ ప్రణాళిక సంచాలకం (DTCP)</strong>, ఆంధ్రప్రదేశ్ రాష్ట్రం అంతటా వ్యవస్థీకృత మరియు ప్రణాళికాబద్ధమైన పట్టణ మరియు గ్రామీణ అభివృద్ధికి బాధ్యత వహించే అత్యున్నత చట్టబద్ధ సంస్థ. ఆంధ్రప్రదేశ్ టౌన్ ప్లానింగ్ చట్టం కింద స్థాపించబడిన DTCP ఒక శతాబ్దానికి పైగా పట్టణ స్థావరాల వృద్ధికి మార్గనిర్దేశం చేస్తోంది.',
  'about.description2': 'DTCP అన్ని పట్టణ స్థానిక సంస్థల కోసం మాస్టర్ ప్లాన్లను రూపొందిస్తుంది, భవన అనుమతులు మరియు లేఅవుట్ ఆమోదాలు జారీ చేస్తుంది, అభివృద్ధి నియంత్రణ నిబంధనల ప్రకారం భూ వినియోగాన్ని నియంత్రిస్తుంది మరియు CRDA, GHMC, మున్సిపల్ కార్పొరేషన్లు మరియు ఇతర ప్రణాళిక అధికారులతో సమన్వయంతో స్థానిక ప్రభుత్వాలకు సాంకేతిక మార్గదర్శనం అందిస్తుంది.',
  'about.mission': 'మా లక్ష్యం',
  'about.missionText': 'AP పట్టణ మరియు గ్రామీణ ప్రాంతాల ప్రణాళికాబద్ధమైన, సమ్మిళిత మరియు స్థిరమైన అభివృద్ధిని ప్రోత్సహించడం',
  'about.vision': 'మా దృష్టి',
  'about.visionText': '2041 నాటికి ఆంధ్రప్రదేశ్ అంతటా స్థితిస్థాపకమైన, నివాసయోగ్యమైన మరియు భవిష్యత్-సిద్ధ పట్టణాలు మరియు నగరాలు',
  'about.cta': 'DTCP గురించి మరింత తెలుసుకోండి',
  'about.yearsOfPlanning': 'సంవత్సరాల ప్రణాళిక',
  'about.stat.ulb': 'పట్టణ స్థానిక సంస్థలు',
  'about.stat.permissions': 'జారీ చేసిన అనుమతులు',
  'about.stat.masterPlans': 'సిద్ధం చేసిన మాస్టర్ ప్లాన్లు',
  'about.stat.citizens': 'సేవలందించిన పౌరులు',
  'about.description': 'పట్టణ మరియు గ్రామీణ ప్రణాళిక సంచాలకం (DTCP) ఆంధ్రప్రదేశ్‌లో పట్టణ ప్రణాళిక మరియు అభివృద్ధి నియంత్రణ కోసం అత్యున్నత సంస్థ.',
  'about.subtitle': 'మెరుగైన రేపటి కోసం ప్రణాళిక',

  // Leadership
  'leadership.title': 'మా నాయకత్వం',

  // Key Services
  'keyServices.title': 'ముఖ్య సేవలు',
  'keyServices.viewAll': 'అన్ని సేవలు చూడండి',
  'keyServices.buildingPermissions': 'భవన అనుమతులు',
  'keyServices.layoutApprovals': 'లేఅవుట్ ఆమోదాలు',
  'keyServices.landUseCertificate': 'భూ వినియోగ ధృవీకరణ పత్రం',
  'keyServices.masterPlanAccess': 'మాస్టర్ ప్లాన్ యాక్సెస్',
  'keyServices.regularization': 'క్రమబద్ధీకరణ',
  'keyServices.ltp': 'లైసెన్స్‌డ్ టెక్నికల్ పర్సనల్',
  'keyServices.municipalAssets': 'మున్సిపల్ ఆస్తులు',
  'keyServices.ucims': 'UCIMS',

  // Quick Access
  'quickAccess.title': 'త్వరిత ప్రాప్తి',
  'quickAccess.buildingPermission': 'భవన అనుమతి',
  'quickAccess.layoutApproval': 'లేఅవుట్ ఆమోదం',
  'quickAccess.masterPlans': 'మాస్టర్ ప్లాన్లు',
  'quickAccess.onlineApplications': 'ఆన్‌లైన్ దరఖాస్తులు',
  'quickAccess.goOrders': 'GO & ఉత్తర్వులు',
  'quickAccess.citizenServices': 'పౌర సేవలు',
  'quickAccess.regularization': 'క్రమబద్ధీకరణ',
  'quickAccess.landUseCertificate': 'భూ వినియోగ ధృవీకరణ పత్రం',

  // UDA Map
  'uda.title': 'పట్టణ అభివృద్ధి ప్రాధికార సంస్థలు',
  'uda.subtitle': 'ఆంధ్రప్రదేశ్ అంతటా {{count}} UDAలను అన్వేషించండి',
  'uda.badge': '{{count}} UDAలు',
  'uda.listTitle': 'UDAలు',
  'uda.search': 'UDA వెతకండి...',
  'uda.district': 'జిల్లా',

  // Resources
  'resources.title': 'వనరులు',
  'resources.description': 'పట్టణ ప్రణాళిక మరియు పట్టణ అభివృద్ధికి సంబంధించిన చట్టాలు, ప్రభుత్వ ఉత్తర్వులు, తరచుగా అడిగే ప్రశ్నలు మరియు శిక్షణ సామగ్రి.',
  'resources.actsByLaws': 'చట్టాలు & ఉపనియమాలు',
  'resources.gosCirculars': "GO లు & సర్క్యులర్‌లు",
  'resources.faqs': 'తరచుగా అడిగే ప్రశ్నలు',
  'resources.trainingMaterials': 'శిక్షణ సామగ్రి',

  // Citizen Services
  'citizen.title': 'పౌర సేవలు',
  'citizen.trackTitle': 'మీ దరఖాస్తును ట్రాక్ చేయండి',
  'citizen.trackSubtitle': 'స్థితి తనిఖీ చేయడానికి మీ రిఫరెన్స్ నంబర్ నమోదు చేయండి',
  'citizen.trackPlaceholder': 'ఉదా. DTCP/BP/2026/04521',
  'citizen.checkStatus': 'స్థితి తనిఖీ చేయండి',
  'citizen.found': 'దరఖాస్తు కనుగొనబడింది',
  'citizen.notFound': 'దరఖాస్తు కనుగొనబడలేదు',
  'citizen.notFoundMsg': 'దయచేసి మీ రిఫరెన్స్ నంబర్ ధృవీకరించి మళ్ళీ ప్రయత్నించండి.',

  // Online Services
  'online.title': 'ఆన్‌లైన్ పోర్టల్‌లు & సేవలు',
  'online.visitPortal': 'పోర్టల్ సందర్శించండి',
  'online.helpTitle': 'మీ దరఖాస్తుతో సహాయం కావాలా?',
  'online.helpSubtitle': 'ఏవైనా ప్రశ్నలకు మా సపోర్ట్ టీమ్ సహాయం చేయడానికి అందుబాటులో ఉంది',
  'online.callNow': 'ఇప్పుడు కాల్ చేయండి',
  'online.raiseGrievance': 'ఫిర్యాదు చేయండి',

  // Announcements
  'announcements.title': 'వార్తలు & ప్రకటనలు',
  'announcements.news': 'వార్తలు & నవీకరణలు',
  'announcements.notices': 'ముఖ్యమైన నోటీసులు',
  'announcements.viewAll': 'అన్నీ చూడండి',
  'announcements.tabNews': 'వార్తలు',
  'announcements.tabCirculars': 'సర్క్యులర్‌లు',
  'announcements.tabTenders': 'టెండర్లు',

  // Gallery
  'gallery.title': 'గ్యాలరీ',
  'gallery.photo': 'ఫోటో',
  'gallery.imagesAndVideos': 'చిత్రాలు & వీడియోలు',
  'gallery.images': 'చిత్రాలు',
  'gallery.videos': 'వీడియోలు',
  'gallery.noVideos': 'ఇంకా వీడియోలు ప్రచురించబడలేదు',
  'gallery.prev': 'మునుపటి',
  'gallery.next': 'తదుపరి',
  'location.title': 'మా స్థానం',
  'location.fullScreen': 'పూర్తి స్క్రీన్',
  'location.exitFullScreen': 'పూర్తి స్క్రీన్ నుండి నిష్క్రమించండి',

  // Services Section (legacy)
  'services.title': 'DTCP సేవలు',
  'services.description': 'విస్తృత శ్రేణి పట్టణ ప్రణాళిక సేవలను ఆన్‌లైన్‌లో యాక్సెస్ చేయండి.',
  'services.ctaTitle': 'DTCP సేవలను ఆన్‌లైన్‌లో యాక్సెస్ చేయండి',
  'services.ctaDescription': 'ప్రణాళిక సేవల పూర్తి శ్రేణిని యాక్సెస్ చేయడానికి DTCP పోర్టల్‌లోకి లాగిన్ అవ్వండి.',
  'services.ctaButton': 'ప్రారంభించండి',

  // Services Section — UI controls
  'services.searchPlaceholder': 'సేవలను శోధించండి...',
  'services.expandAll': 'అన్నీ విస్తరించండి',
  'services.collapseAll': 'అన్నీ కుదించండి',
  'services.serviceSingular': 'సేవ',
  'services.servicePlural': 'సేవలు',
  'services.noResults': 'సేవలు ఏవీ కనుగొనబడలేదు',
  'services.adjustSearch': 'మీ శోధన పదాన్ని సర్దుబాటు చేసి మళ్ళీ ప్రయత్నించండి',
  'services.close': 'మూసివేయండి',
  'services.ddRulesPanelTitle': 'డిస్ప్లే పరికరాలు — నిబంధనలు, ఫీజులు & FAQ (GO Ms.No.253)',

  // Services Section — Category titles
  'services.cat.bp.title': 'ఆన్‌లైన్ భవన అనుమతులు (APDPMS)',
  'services.cat.la.title': 'లేఅవుట్ ఆమోదాలు',
  'services.cat.lrs.title': 'లేఅవుట్ క్రమబద్ధీకరణ పథకం (LRS)',
  'services.cat.bps.title': 'భవన శిక్షణ పథకం (BPS)',
  'services.cat.clu.title': 'భూ వినియోగ మార్పు / NALA',
  'services.cat.mp.title': 'మాస్టర్ ప్లాన్‌లు',
  'services.cat.tdr.title': 'బదిలీ చేయదగిన అభివృద్ధి హక్కులు (TDR)',
  'services.cat.dd.title': 'డిస్ప్లే పరికరాలు (GO Ms.No.253)',
  'services.cat.tt.title': 'టెలికాం టవర్ అనుమతులు',
  'services.cat.st.title': 'స్మార్ట్ టౌన్‌షిప్‌లు',
  'services.cat.uda.title': 'UDA సేవలు',

  // Services Section — Sub-service labels
  'services.item.bp-1': 'భవన అనుమతి కోసం దరఖాస్తు చేయండి',
  'services.item.bp-2': 'దరఖాస్తు స్థితిని ట్రాక్ చేయండి',
  'services.item.bp-3': 'ఆమోదిత ప్లాన్‌లను డౌన్‌లోడ్ చేయండి',
  'services.item.bp-4': 'ఆక్యుపెన్సీ సర్టిఫికేట్',
  'services.item.bp-5': 'పూర్తి సర్టిఫికేట్',
  'services.item.la-1': 'లేఅవుట్ అనుమతి కోసం దరఖాస్తు చేయండి',
  'services.item.la-2': 'లేఅవుట్ దరఖాస్తు స్థితిని ట్రాక్ చేయండి',
  'services.item.la-3': 'లేఅవుట్ ఆమోదాలను డౌన్‌లోడ్ చేయండి',
  'services.item.lrs-1': 'LRS కోసం దరఖాస్తు చేయండి',
  'services.item.lrs-2': 'LRS దరఖాస్తు స్థితిని ట్రాక్ చేయండి',
  'services.item.lrs-3': 'LRS ఫీజు కాలిక్యులేటర్',
  'services.item.lrs-4': 'LRS సర్టిఫికేట్‌ను డౌన్‌లోడ్ చేయండి',
  'services.item.lrs-5': 'LRS పథకం గురించి',
  'services.item.bps-1': 'BPS కోసం దరఖాస్తు చేయండి',
  'services.item.bps-2': 'BPS దరఖాస్తు స్థితిని ట్రాక్ చేయండి',
  'services.item.bps-3': 'BPS జరిమానా కాలిక్యులేటర్',
  'services.item.bps-4': 'BPS సర్టిఫికేట్‌ను డౌన్‌లోడ్ చేయండి',
  'services.item.bps-5': 'BPS పథకం గురించి',
  'services.item.clu-1': 'భూ వినియోగ మార్పు కోసం దరఖాస్తు చేయండి',
  'services.item.clu-2': 'NALA దరఖాస్తు',
  'services.item.clu-3': 'దరఖాస్తు స్థితిని ట్రాక్ చేయండి',
  'services.item.mp-1': 'మాస్టర్ ప్లాన్‌లను చూడండి',
  'services.item.mp-2': 'జోనింగ్ సమాచారం',
  'services.item.mp-3': 'భూ వినియోగ వర్గీకరణ',
  'services.item.tdr-1': 'TDR కోసం దరఖాస్తు చేయండి',
  'services.item.tdr-2': 'TDR దరఖాస్తును ట్రాక్ చేయండి',
  'services.item.tdr-3': 'TDR సర్టిఫికేట్',
  'services.item.dd-1': 'డిస్‌ప్లేయర్ లైసెన్స్ కోసం దరఖాస్తు చేయండి',
  'services.item.dd-2b': 'పరికర అనుమతి కోసం దరఖాస్తు (తాత్కాలిక)',
  'services.item.dd-3': 'వర్క్‌ఫ్లో స్థితిని ట్రాక్ చేయండి',
  'services.item.dd-4': 'డిమాండ్‌లు & వసూళ్లను చూడండి',
  'services.item.dd-5': 'డిస్ప్లే పరికరాల డాష్‌బోర్డ్',
  'services.item.dd-6': 'నిబంధనలు, ఫీజులు & FAQ (GO Ms.No.253)',
  'services.item.tt-1': 'టవర్ క్లియరెన్స్ కోసం దరఖాస్తు చేయండి',
  'services.item.tt-2': 'దరఖాస్తు స్థితిని ట్రాక్ చేయండి',
  'services.item.st-1': 'స్మార్ట్ టౌన్‌షిప్ దరఖాస్తు',
  'services.item.st-2': 'దరఖాస్తు స్థితిని ట్రాక్ చేయండి',
  'services.item.uda-1': 'UDA భవన అనుమతులు',
  'services.item.uda-2': 'UDA లేఅవుట్ ఆమోదాలు',
  'services.item.uda-3': 'UDA అభివృద్ధి ఛార్జీలు',
  'services.item.uda-4': 'UDA ప్రాంతీయ సేవలు',

  // Contact Section
  'contact.title': 'సంప్రదించండి',
  'contact.description': 'భవన అనుమతులు, లేఅవుట్ ఆమోదాలు, మాస్టర్ ప్లాన్లు మరియు ఇతర పట్టణ ప్రణాళిక సేవలకు సంబంధించిన ప్రశ్నల కోసం DTCP ని సంప్రదించండి.',
  'contact.headOffice': 'DTCP ప్రధాన కార్యాలయం',
  'contact.headOfficeDesc': 'పట్టణ మరియు గ్రామీణ ప్రణాళిక సంచాలకం, ఆంధ్రప్రదేశ్ ప్రభుత్వం.',
  'contact.regionalOffices': 'ప్రాంతీయ కార్యాలయాలు',
  'contact.regionalOfficesDesc': 'ఆంధ్రప్రదేశ్ అంతటా DTCP 4 ప్రాంతీయ కార్యాలయాలను కలిగి ఉంది.',
  'contact.helpDesk': 'హెల్ప్ డెస్క్',
  'contact.helpDeskDesc': 'ఆన్‌లైన్ సేవలు, అప్లికేషన్ స్థితి మరియు సాధారణ సమాచారానికి సంబంధించిన ప్రశ్నల కోసం.',
  'contact.helpline': 'హెల్ప్‌లైన్',
  'contact.emailSupport': 'ఇమెయిల్',
  'contact.supportHours': 'పని గంటలు',
  'contact.contactHeadOffice': 'ప్రధాన కార్యాలయాన్ని సంప్రదించండి',
  'contact.viewRegionalOffices': 'ప్రాంతీయ కార్యాలయాలను చూడండి',
  'contact.getHelp': 'సహాయం పొందండి',
  'contact.downloads': 'డౌన్‌లోడ్‌లు & వనరులు',
  'contact.applicationForms': 'దరఖాస్తు ఫారాలు',
  'contact.feeStructure': 'ఫీజు నిర్మాణం',
  'contact.developmentRules': 'అభివృద్ధి నియంత్రణ నియమాలు',
  'contact.masterPlans': 'మాస్టర్ ప్లాన్లు',
  'contact.updates': 'తాజా నవీకరణలు',
  'contact.gosCirculars': "GO లు & సర్క్యులర్‌లు",
  'contact.tenders': 'టెండర్లు & నోటీసులు',
  'contact.pressReleases': 'ప్రెస్ విడుదలలు',
  'contact.recruitments': 'నియామకాలు',
};
